<template>
  <div class="body-container login">
    <div class="login-title">欢迎登录</div>
    <div class="login-box">
      <div class="input-box">
        <img src="@static/images/login/tel.png" />
        <input type="number" placeholder="请输入手机号" v-model.trim="account" />
      </div>
      <div class="input-box">
        <img src="@static/images/login/code.png" />
        <input type="number" placeholder="请输入验证码" v-model.trim="code" />
        <div class="code-btn blue" @click="getCodeAjax(account)" v-if="codeIndex==CODE_SIZE">获取验证码</div>
        <div class="code-btn" v-else>{{codeIndex}}S</div>
      </div>
      <!-- <div class="bottom-text">
        <div class="checkBox" @click="active=!active">
          <div class="btns" :class="{active}">
            <div class="circle"></div>
          </div>
        </div>
        <div class="txtBox">
          登录即代表同意
          <span @click="jumpPage('/apps/public/agreement.html')">《用户服务协议》</span>、
          <span @click="jumpPage('/apps/public/privacy.html')">《隐私政策》</span>
        </div>
      </div> -->
      <van-button round class="form-btn" @click="submit">登录</van-button>
      <div class="btn" @click="goLogin">密码登录</div>
    </div>
  </div>
</template>

<script>
import wxAPI from "@/api/weixin";
import { common, codeTools } from "@/api/mixins";
export default {
  mixins: [common, codeTools],
  data() {
    return {
      active: false,
      appid: "",
      openid: "",
      account: "",
      code: ""
    };
  },
  mounted() {
    this.initInfo();
    if (localStorage.jzy_token) {
      this.loginSuccess();
    }
    this.$weixin.hideMenu();
  },
  watch: {
    account(val) {
      const info = sessionStorage.getItem("loginUserInfoByCode");
      if (info) {
        const res = JSON.parse(info);
        res.account = val;
        sessionStorage.setItem("loginUserInfoByCode", JSON.stringify(res));
      } else {
        const res = {};
        res.account = val;
        sessionStorage.setItem("loginUserInfoByCode", JSON.stringify(res));
      }
    },
    code(val) {
      const info = sessionStorage.getItem("loginUserInfoByCode");
      if (info) {
        const res = JSON.parse(info);
        res.code = val;
        sessionStorage.setItem("loginUserInfoByCode", JSON.stringify(res));
      } else {
        const res = {};
        res.code = val;
        sessionStorage.setItem("loginUserInfoByCode", JSON.stringify(res));
      }
    }
  },
  methods: {
    initInfo() {
      const info = sessionStorage.getItem("loginUserInfoByCode");
      if (info) {
        const res = JSON.parse(info);
        this.account = res.account;
        this.code = res.code;
      }
      if (this.$route.query.account) {
        this.account = this.$route.query.account;
      }
    },
    loginSuccess() {
      if (this.$route.query.goPage) {
        location.href = this.$route.query.goPage;
      } else if (sessionStorage.jzyLoginPage) {
        location.href = sessionStorage.jzyLoginPage;
      } else {
        location.href = "/apps/index";
      }
    },
    goLogin() {
      const query = Object.assign({}, this.$route.query);
      if(this.account&&this.$regulars.isPhone(this.account)){
               query.account = this.account;
      }
      query.isCode = true;
      sessionStorage.removeItem("loginUserInfo");
      this.$router.push({
        path: "/apps/login",
        query
      });
    },
    submit() {
      if (!this.$regulars.isPhone(this.account)) {
        this.$notice.msg("请输入正确的手机号码");
        return;
      } else if (!this.code) {
        this.$notice.msg("请输入验证码");
        return;
      } else if (this.code.toString().length != 6) {
        this.$notice.msg("请输入6位验证码");
        return;
      } else if (!this.active) {
        // this.$notice.msg("请阅读并同意协议");
        // return;
      }
      this.loading = true;
      this.$http({
        type: "POST",
        url: "/api/user/loginByCode",
        data: {
          orgId: sessionStorage.orgId || '',
          openid: this.openid,
          username: this.account,
          code: this.code
        }
      })
        .then(resData => {
          localStorage.jzy_token = resData.data.token;
          localStorage.jzy_user = JSON.stringify(resData.data);
          this.loading = false;
          this.loginSuccess();
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./login";
</style>
